import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useTranslation } from "react-i18next";
import { useGetAllCostBy } from "../api/getAllCostBy";

// All your logic is here
export const useCostByDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetCostBy []>([]);
  const getCostByQuery = useGetAllCostBy({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getCostByQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getCostByQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getCostByQuery.data ? getCostByQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Κόστος ανά",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Κόστος ανά");
        break;
      case "edit":
        title = t("Επεξεργασία Κόστος ανά");
        break
        case "delete":
        title = t("Διαγραφή Κόστος ανά");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getCostByQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
